var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',{attrs:{"data":_vm.tableData,"row-key":"id","tree-props":{ children: 'children' },"default-expand-all":true}},[_c('el-table-column',{attrs:{"prop":"label","label":_vm.thirdLevelLabel}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":"設定値"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }